//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _doingCreate_metadata_deployment from './doingCreate_metadata_deployment';
export const doingCreate_metadata_deployment = _doingCreate_metadata_deployment;
export default {doingCreate_metadata_deployment};

